import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-wider text-primary-600">
            {icon && <i className={`${icon} text-base`} />}
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        {children}
        {moreTo && (
          <Link
            to={moreTo}
            className="inline-flex items-center gap-1 rounded-md px-3 py-2 text-sm font-label text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-line text-base" />
          </Link>
        )}
      </div>
    </div>
  );
}